module.exports = __webpack_public_path__ + "img/reminders-2-mobile.c830fa54.gif";